/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cat_Siparisler_TitleInputs */

const tr_faq_cat_siparisler_title = /** @type {(inputs: Faq_Cat_Siparisler_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siparişler ve İşleyiş`)
};

const en_faq_cat_siparisler_title = /** @type {(inputs: Faq_Cat_Siparisler_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders`)
};

const de_faq_cat_siparisler_title = /** @type {(inputs: Faq_Cat_Siparisler_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellungen`)
};

const ru_faq_cat_siparisler_title = /** @type {(inputs: Faq_Cat_Siparisler_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заказы`)
};

/**
* | output |
* | --- |
* | "Orders" |
*
* @param {Faq_Cat_Siparisler_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_cat_siparisler_title = /** @type {((inputs?: Faq_Cat_Siparisler_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cat_Siparisler_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_cat_siparisler_title(inputs)
	if (locale === "de") return de_faq_cat_siparisler_title(inputs)
	if (locale === "ru") return ru_faq_cat_siparisler_title(inputs)
	return tr_faq_cat_siparisler_title(inputs)
});